const SimpleFlex = (props) => {
    return(
        <div style={{display:'flex',flex:1}}>
            {props.children}
        </div>
    )
}
export {SimpleFlex}